import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ModalComponent.less';
const ESC_KEY = 27;
const INITIAL_FOCUS_SELECTOR = '*[data-initialfocus]';
const DEFAULT_INITIAL_FOCUS_SELECTOR = 'input[type="button"], input[type="submit"], button, a.btn';
const FOCUSABLE_ELEMENTS_STRING = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

let modalRoot; // pop-up element
let focusedElementBeforeModal; // element to return the focus on close
let defaultFocusElement; // default focus element - CTA button
let firstFocusElement; // first focus item

export class ModalComponent extends Component {
    static propTypes = {
        allowEscKey: PropTypes.bool,
        onClose: PropTypes.func,
        showUnderlay: PropTypes.bool,
        children: PropTypes.node
    };

    static defaultProps = {
        allowEscKey: true,
        showUnderlay: true
    };

    constructor(props) {
        super(props);

        // save the current focus element so that we can return the focus on close
        focusedElementBeforeModal = document.querySelector(':focus');
    }


    componentDidMount() {
        if (this.props.allowEscKey) {
            document.addEventListener('keydown', this.onEscapeKey);
        }

        modalRoot = document.getElementById('cape-modal');

        if (modalRoot && modalRoot.querySelector) {
            document.addEventListener('focus', this.onFocus, true);

            // set the focus to the CTA element
            defaultFocusElement = modalRoot.querySelector(INITIAL_FOCUS_SELECTOR) || modalRoot.querySelector(DEFAULT_INITIAL_FOCUS_SELECTOR);
            defaultFocusElement && defaultFocusElement.focus();

            const focusElements = modalRoot.querySelectorAll(FOCUSABLE_ELEMENTS_STRING) || [];
            firstFocusElement = focusElements[0];
        }
    }

    componentWillUnmount() {
        // return the focus back to the caller
        focusedElementBeforeModal && focusedElementBeforeModal.focus();

        document.removeEventListener('keydown', this.onEscapeKey);
        document.removeEventListener('focus', this.onFocus);
    }

    onEscapeKey = event => {
        const { onClose } = this.props;

        if (event && event.keyCode === ESC_KEY) {
            onClose && onClose(event);
        }
    };

    onFocus = event => {
        if (modalRoot && !modalRoot.contains(event.target)) {
            firstFocusElement && setTimeout(() => firstFocusElement.focus(), 0);
        }
    };

    render() {
        const { children, showUnderlay } = this.props;

        return (
            <div className="ModalComponent">
                {showUnderlay && <div id="underlay" />}
                <div id="cape-modal" className="vertical-middle text-center" role="dialog">{children}</div>
            </div>
        );
    }
}

export default ModalComponent;
